import { render, staticRenderFns } from "./PageDrawer.vue?vue&type=template&id=1c9fc027&scoped=true"
import script from "./PageDrawer.vue?vue&type=script&lang=js"
export * from "./PageDrawer.vue?vue&type=script&lang=js"
import style0 from "./PageDrawer.vue?vue&type=style&index=0&id=1c9fc027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9fc027",
  null
  
)

export default component.exports